@if (actionError(); as message) {
  <div hlmAlert variant="destructive">
    <ng-icon name="lucideTriangleAlert" />
    <p hlmAlertDescription>{{ message }}</p>
  </div>
}
@if (error(); as message) {
  <div hlmAlert variant="destructive">
    <ng-icon name="lucideTriangleAlert" />
    <p hlmAlertTitle>{{ message }}</p>
    <p hlmAlertDescription>
      <button hlmBtn variant="link" size="sm" type="button" (click)="load()">
        Erneut versuchen
      </button>
    </p>
  </div>
}
<app-active-designs
  [designs]="designs()"
  [loading]="loading()"
  [previewingId]="previewingId()"
  (switchSlot)="openSwitch($event)"
  (preview)="previewPdf($event)" />

<app-design-library
  [designs]="designs()"
  [loading]="loading()"
  [busyId]="busyId()"
  (activate)="askActivate($event)"
  (copy)="copy($event)"
  (delete)="askDelete($event)"
  (create)="newDesignOpen.set(true)" />

<app-new-design-dialog
  [open]="newDesignOpen()"
  (created)="onCreated($event)"
  (close)="newDesignOpen.set(false)" />

<app-switch-design-dialog
  [voucherType]="switchSlot()"
  [designs]="designs()"
  [activeId]="switchActiveId()"
  [busyId]="busyId()"
  (choose)="chooseForSlot($event)"
  (close)="closeSwitch()" />

<hlm-alert-dialog [state]="pending() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-alert-dialog-content *hlmAlertDialogPortal class="max-w-lg">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>{{ dialogTitle() }}</h3>
      <p hlmAlertDialogDescription>{{ dialogText() }}</p>
    </div>
    <div hlmAlertDialogFooter>
      <button hlmAlertDialogCancel hlmBtn variant="outline" (click)="cancelPending()">
        Abbrechen
      </button>
      <button
        hlmAlertDialogAction
        hlmBtn
        [variant]="pending()?.kind === 'delete' ? 'destructive' : 'default'"
        (click)="confirmPending()">
        {{ pending()?.kind === 'delete' ? 'Löschen' : 'Verwenden' }}
      </button>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
